import React, { Component } from 'react';
import * as Config from '../config/Config';

export default class Thankspage extends Component {

  render() {

    const {data}=this.props;

    return (
      <div >
      <h1>PIN Registration</h1>
    <div className="gray-box-reg">

      <section id="semana-scroll-register" className="scroll1">

        <section className="viewport">
          <section className="overview">
            <div className="innerfull" style={{minHeight:'250px',fontSize:'15px',lineHeight:'20px'}}> You have successfully registered for the program <span  className="redtxt-prod"><strong>
              {data.product_name}
              .</strong></span> <br />
              <br />
              <span className="access-text">You can now access your learning space with the following credentials (please note these down with you). </span> <br/>
              <ul className="user-thanks">
                {/* <li><span>URL :</span><a href="#/login"></a></li>*/}
                <li><span>Username :</span>{data.primaryemail}</li>
                <li><span>Initial Password :</span>{data.password}</li>
                {data.unique_app_code!=null &&
                <li><span>Appcode :</span>{data.unique_app_code}</li>
                }
              </ul>
              <br/>
              <br/>
              After logging in, you may change your password, after which your 'Initial Password' will not hold good anymore. <br/>
              <br/>
              You will get our mail communication from <a href={`mailto:admin@361dm.com`}>admin@361dm.com</a> and <a href={`mailto:puja@361dm.com`}>puja@361dm.com</a>. Remember to look into your spam box too. <br/>
              <br/>
              <div className="button"><span>
              <a href={Config.rootDomainUrl} className="btn-green">Continue to Login</a>

                </span> </div>
            </div>
          </section>
        </section>
      </section>
    </div>
   </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/auth/Thankspage.js